import { z } from 'zod';

/** What every installed integration (GPS, SMS, WhatsApp) shares: its name and a config generated from the vendor's own schema. */

/** One input of an install form, derived from the vendor's Zod config schema. */
export interface ConfigField {
  name: string;
  label: string;
  help?: string;
  /** Encrypted at rest, write-only in the form, never returned by the API. */
  secret: boolean;
  type: 'text' | 'number' | 'boolean';
  required: boolean;
  /** Fields that belong together after the credentials (WhatsApp's "Sign-in codes"); the form puts a heading over each new section. */
  section?: string;
}

export const integrationDisplayNameSchema = z.string().trim().min(1).max(100);

/** Validated against the vendor's own schema by the API; here only that it is a flat bag of values. */
export const integrationConfigValuesSchema = z.record(z.string(), z.union([z.string(), z.number(), z.boolean()]));
export type IntegrationConfigValues = z.infer<typeof integrationConfigValuesSchema>;

/** A provider in a messaging catalogue (SMS, WhatsApp): what the Add sheet lists and the install form renders. */
export interface MessagingProviderSummary {
  key: string;
  displayName: string;
  logoSvg: string;
  fields: ConfigField[];
}
